import Notifier from 'common/helpers/Notifier';
import { useFind } from 'src/api/APIHooks';

export const useFindProvidedServices = (caseId) => {
  const providedServiceQuery = useFind(
    'provided_service',
    { case: caseId },
    {
      queryConfig: {
        enabled: !!caseId,
        onError: () => Notifier.dispatch(
          'error',
          'Provided Services information cannot be displayed',
        ),
        placeholderData: undefined,
      },
    },
  );

  return {
    providedServices: providedServiceQuery?.data?.data?.data ?? [],
    ...providedServiceQuery,
  };
};
